import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { useNavigate} from "react-router-dom";
import MDButton from "../../../components/MDButton";
import { CircularProgress } from "@mui/material";
import { storeUser } from "../../../actions/users/user";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";

export default function CreateUserComponent(){
  const router = useNavigate();
  const [pending , setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isOptionSelected, setIsOptionSelected] = useState(false);
  async function storeNewUser(e){

    e.preventDefault();

    const formData = new FormData(e.target);
    setLoading(true);
    const state = await storeUser(formData);
    setLoading(false);
    if(state.status === "success"){
      toast.success(state.message);
      router('/users');
    }else{
      toast.error(state.message);
    }
  }
  const changeTextColor = () => {
    setIsOptionSelected(true);
  };
  return (
    <DashboardLayout>
      <div className="flex flex-col gap-9">
        <form onSubmit={storeNewUser}>
          <div
            className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className="border-b border-stroke px-6 py-4 dark:border-strokedark">
              <h3 className="font-medium text-black dark:text-white">
                مشخصات کاربر
              </h3>
            </div>
            <div className="flex flex-col gap-5 p-6">
              <div className="flex flex-wrap gap-5">
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    نام و نام خانوادگی
                  </label>
                  <input
                    type="text"
                    name='name'
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    نام کاربری
                  </label>
                  <input
                    name='username'
                    type="text"
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>

              </div>

              <div className="flex flex-wrap gap-5">
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    رمز عبور
                  </label>
                  <input
                    type="password"
                    name='password'
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    کد ملی
                  </label>
                  <input
                    name="melli_code"
                    type="text"
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>

              </div>
              <div className="flex flex-wrap gap-5">
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    سمت
                  </label>
                  <input
                    name="position"
                    type="text"
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    نقش
                  </label>
                  <select
                    name="role"
                    value={selectedOption}
                    onChange={(e) => {
                      setSelectedOption(e.target.value);
                      changeTextColor();
                    }}
                    className={`text-sm relative z-20 w-full appearance-none rounded border border-stroke bg-transparent px-12 py-3 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input ${
                      isOptionSelected ? "text-black dark:text-white" : ""
                    }`}
                  >
                    <option value="0" className="text-body dark:text-bodydark">
                      کاربر اپلیکیشن
                    </option>
                    <option value="1" className="text-body dark:text-bodydark">
                      ادمین
                    </option>

                  </select>

                </div>

              </div>
              <div className="flex flex-wrap gap-5">
                <div className="flex-1">
                  <label className="mb-3 block text-sm font-medium text-black dark:text-white">
                    شماره موبایل
                  </label>
                  <input
                    name="cellphone"
                    type="number"
                    placeholder="..."
                    className="w-full rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                  />

                </div>
                <div className="flex-1" />
              </div>
              <div className={"flex mt-10 w-1/5"}>
                {pending ? (
                  <MDButton disabled color="info" variant="gradient" fullWidth>
                    <CircularProgress size={25} color={"white"} />
                  </MDButton>
                ) : (
                  <MDButton type={"submit"} color="info" variant="gradient" fullWidth>
                    ایجاد
                  </MDButton>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
}